import React, { Component } from 'react';
import { translate } from 'react-i18next';

import Input from 'antd/lib/input';

@translate()
export default class PasswordInput extends Component {
  state = {
    passwordVisible: false,
  };

  onPasswordVisibleChange = () => {
    this.setState(prevState => ({
      passwordVisible: !prevState.passwordVisible,
    }));
  };

  renderLabel = () => {
    const { t } = this.props;
    const { passwordVisible } = this.state;

    return (
      <label onClick={this.onPasswordVisibleChange} style={{ cursor: 'pointer', marginRight: 12 }}>
        {t(passwordVisible ? 'Skryť heslo' : 'Zobraziť heslo')}
      </label>
    );
  };

  render() {
    const { t, ...props } = this.props;
    const { passwordVisible } = this.state;

    return (
      <Input
        {...props}
        size="default"
        type={passwordVisible ? 'text' : 'password'}
        suffix={props.value ? this.renderLabel() : undefined}
        className={props.value ? '' : 'no-value'}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/PasswordInput.js